import * as shape from 'd3-shape';
import React from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, TouchableOpacity, View } from 'react-native';
import { connect } from 'react-redux';
import Theme from '../../theme';
import { SkeletonLoader } from '../../ui/components/SkeletonLoader.native';
import { defaultScale, graphScale, fullScale } from '../../utils/scaling';
import { TileHeader } from './TileHeader';
import { TrackingLineGraph } from './TrackingLineGraph';

const EffortPointGraphComponent = ({
  userProfile,
  t,
  weeklyWorkoutStatsIsLoading,
  weeklyWorkoutStats,
  effortPointGraphYMax,
  effortPointGraphYMin,
  navigation,
  hasLastWorkout,
}) => {
  const hasHeartRateMonitor = userProfile && !!userProfile.heartRateMonitorIdentifier;
  if (weeklyWorkoutStatsIsLoading) {
    return <View style={styles.mainTileContainer}>
      <SkeletonLoader containerStyle={{ height: defaultScale(300) }} />
    </View>;
  }

  if (!hasHeartRateMonitor) {
    return <></>;
  }

  if (hasHeartRateMonitor && !hasLastWorkout) {
    // Make no sense to show anything when hr monitor connected but no prior workouts
    return <></>;
  }

  return (
    <TouchableOpacity
      style={styles.mainTileContainer}
      onPress={() => { navigation.navigate('TrackingWorkoutStats'); }}
    >
      <View style={styles.tile}>
        <TileHeader>{t('weeklyEffortPoints')}</TileHeader>
        {weeklyWorkoutStats.weeklyEffortPoints.graphData &&
          <View style={styles.graphContainer}>
            <TrackingLineGraph
              graphData={weeklyWorkoutStats.weeklyEffortPoints.graphData}
              targetData={null}
              yAxisData={[effortPointGraphYMin, effortPointGraphYMax]}
              yAxisSvg={{ fill: Theme.BLACK }}
              labels={weeklyWorkoutStats.weeklyEffortPoints.graphDateLabels}
              height={graphScale(100)}
              numberOfTicks={20}
              curve={shape.curveLinear}
              showCirclesForAllPoints
            />
          </View>}
      </View>
    </TouchableOpacity>
  );
};

const styles = StyleSheet.create({
  mainTileContainer: {
    marginBottom: defaultScale(15),
  },
  tile: {
    backgroundColor: Theme.WHITE,
    paddingTop: defaultScale(24),
    paddingHorizontal: defaultScale(16),
  },
  effortPointsTileHeader: {
    ...Theme.textStyle.heading,
  },
  seeAll: {
    ...Theme.textStyle.bodyCopyBold,
    color: Theme.PRIMARY,
    alignSelf: 'flex-end',
  },
  tileHeader: {
    flexDirection: 'row',
    flex: 1,
    justifyContent: 'space-between',
  },
  graphContainer: {
    paddingTop: defaultScale(30),
    paddingBottom: fullScale(8),
    paddingRight: fullScale(6),
  },
});

const mapStateToProps = (state: any) => {
  return {
    weeklyWorkoutStatsIsLoading: state.tracking.view.weeklyWorkoutStatsIsLoading,
    weeklyWorkoutStats: state.tracking.data.weeklyWorkoutStats,
    hasLastWorkout: state.tracking.data.hasLastWorkout,
    lastWorkoutHasMetrics: state.tracking.data.lastWorkoutHasMetrics,
    effortPointGraphYMax: state.tracking.data.effortPointGraphYMax,
    effortPointGraphYMin: state.tracking.data.effortPointGraphYMin,
  };
};

export const EffortPointGraph =
  connect(mapStateToProps)(
    translate(['tracking'], { wait: true })(EffortPointGraphComponent));
